import React, { Component } from 'react';
import { connect } from "react-redux";
import ArticleDetailComponent from '../../../components/troubleShooting/articleDetails/ArticleDetailsComponent';

import FeedbackContainer from "../../../containers/troubleShooting/articleDetails/FeedbackContainer";

import { getArticleDetailAction, getPageDataAction, SaveAccessFootPrintAction, UpdateAccessFootPrintAction } from "../../../store/troubleShooting/articleDetail/action";
import { checkAuthAction } from "../../../store/auth/action";
import LoaderComponent from '../../../components/layout/loaderComponent';
import ErrorContainer from "../../../containers/ErrorContainer";

class ArticleDetailContainer extends Component {
  constructor(props) {

    super(props);

    console.log(this.props.authData.auth.userId);

    //this.sessionID = (this.props.authData.auth && this.props.authData.auth.sessionId) ? this.props.authData.auth.sessionId : '';
    this.searchOpt = this.props.location.state ? this.props.location.state.searchOption : {};
    this.articleId = this.props.match.params.articleID;

    this.accessLogID = '';
    this.acessFPReq = {
      save:
      {
        AddAccessLogRequest:
        {
          //sessionID: this.sessionID,
          articleID: this.articleId,
          answerID: this.articleId,
          title: '',
          productCategory: (this.searchOpt && this.searchOpt.search_key === "category" ? this.searchOpt.category_names : ""),
          searchKeyword: (this.searchOpt && this.searchOpt.search_key === "free-text" ? this.searchOpt.search_value : "")
        }
      },
      update: {
        UpdateAccessLogRequest: {
          accessLogID: this.accessLogID
        }
      }
    };
    this.scripts = [];

  }
  /**
   * update accesslog
   * remove beforeunload listner
   */

  componentWillUnmount() {
    if (this.accessLogId) {
      this.acessFPReq.update.UpdateAccessLogRequest.accessLogID = this.accessLogId;
      this.props.UpdateAccessFootPrint(this.acessFPReq.update);
      window.removeEventListener('beforeunload', this.handleWindowClose);
    }

  }

  /**
   * @param {*} nextProps 
   * @param {*} nextState 
   * get the latest accesslogId
   * Save Accesslog
   */
  shouldComponentUpdate(nextProps, nextState) {

    if (nextProps.articleDetail.accessLogResp && nextProps.articleDetail.accessLogResp.accessLogID !== this.props.articleDetail.accessLogResp.accessLogID) {

      this.accessLogId = nextProps.articleDetail.accessLogResp.accessLogID;
      this.setState({
        articleDetail: {
          accessLogResp: nextProps.articleDetail.accessLogResp
        }
      })
    }

    if ((nextProps.articleDetail.article) && nextProps.articleDetail.article.status === 200 && nextProps.articleDetail.article !== this.props.articleDetail.article) {

      let title = (nextProps.articleDetail.article.data) ? nextProps.articleDetail.article.data.article.title : '';
      this.acessFPReq.save.AddAccessLogRequest.title = title;
      //if (this.sessionID) {
        //this.acessFPReq.save.AddAccessLogRequest.sessionID = this.sessionID;
        this.props.SaveAccessFootprint(this.acessFPReq.save);
      //}
      window.scrollTo(0, 0);
      return true;
    } else {
      return true;
    }

  }

  /**
   * @componentDidMount to call the API or data related activity 
   */
  componentDidMount() {
    this.props.getPageData();
    this.props.getArticleDetail(this.articleId);
    window.addEventListener('beforeunload', this.handleWindowClose);

  }

  /**
   * @method handleWindowClose() 
   * @param {*} e 
   */

  handleWindowClose = (e) => {
    if (this.accessLogId) {
      this.acessFPReq.update.UpdateAccessLogRequest.accessLogID = this.accessLogId;
      this.props.UpdateAccessFootPrint(this.acessFPReq.update);
    }

  }


  /**
   * go to top page
   */
  backToTop = () => {
    this.props.history.goBack();
  }

  render() {

    console.log(this.props.authData.auth.userId);

    return (

      this.props.articleDetail.article.hasOwnProperty('data') ?
      ((this.props.articleDetail.article.data.statusCode === 200) ?

        <div className="">
          {

           (this.props.articleDetail.article.data.article.script && this.props.articleDetail.article.data.article.script.length > 0 ? 
              
              this.props.articleDetail.article.data.article.script.forEach((path) => {  
                
                if(this.scripts.indexOf(path ) === -1 ){

                  const script = document.createElement("script");
                  script.src = path;
                  script.async = true;
                  document.body.appendChild(script);
                  this.scripts.push(path)
                }            
               
              })
            : '')
           
            }
           
         
          <ArticleDetailComponent articleDetail={this.props.articleDetail.article} pageData={this.props.articleDetail.pageData} />
          <FeedbackContainer articleId={this.articleId} clickHandler={this.backToTop} pageData={this.props.articleDetail.pageData}  /> 
        </div> : <ErrorContainer /> ): <LoaderComponent />
        

    )
  }
}


/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  checkAuth: checkAuthAction,
  getPageData: getPageDataAction,
  getArticleDetail: getArticleDetailAction,
  SaveAccessFootprint: SaveAccessFootPrintAction,
  UpdateAccessFootPrint: UpdateAccessFootPrintAction
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  authData: state.auth,
  articleDetail: state.articleDetail

})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArticleDetailContainer);
